<script setup>
import { ref, watch } from 'vue'
import { icons } from "@/enums/enums.js";

const props = defineProps({
    modelValue: String
})

const emit = defineEmits(['update:modelValue'])

const selectedIcon = ref(props.modelValue)

watch(() => props.modelValue, (val) => {
    selectedIcon.value = val
})

const selectIcon = (icon) => {
    selectedIcon.value = icon
    emit('update:modelValue', icon)
}
</script>

<template>
    <v-menu location="bottom">
        <template #activator="{ props }">
            <v-card
                v-bind="props"
                width="280"
                class="pa-3 v-card--hover elevation-1 me-5 mb-5 cursor-pointer"
            >
                <div class="d-flex align-center ga-2">
                    <span class="text-truncate text-black">
                        {{ selectedIcon ? 'Ícone selecionado' : 'Selecione um ícone' }}
                    </span>

                    <v-icon v-if="selectedIcon" size="24">
                        {{ selectedIcon }}
                    </v-icon>
                </div>
            </v-card>
        </template>

        <v-sheet class="pa-2 bg-white" width="280">
            <div class="d-flex flex-wrap ga-2">
                <v-btn
                    v-for="icon in icons"
                    :key="icon"
                    icon
                    variant="text"
                    @click="selectIcon(icon)"
                >
                    <v-icon>{{ icon }}</v-icon>
                </v-btn>
            </div>
        </v-sheet>
    </v-menu>
</template>
